import React from "react";
import ContextMenuWrapper from "./common/ContextMenuWrapper.jsx";
import ToolTip from "./common/ToolTip";
import IncrDecrSimple from "./common/IncrDecrSimple.jsx";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import ColorPickerDot from "./color-picker/ColorPickerDot";

class RulerContextMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isAbs: props.isAbs };
    }

    handleColorChange = (data) => {
        this.props.handleChange('rulerColor', data );
    }

    handleAbsToggle = (e) => {
        // show ruler as an absolute value or as a difference between two points
        e.stopPropagation();
        let isToggleOn = e.target.checked;
        this.setState({ isAbs: isToggleOn }, () => {
            this.props.handleChange('isAbs', { isAbs: isToggleOn });
        });
    }

    handleFlipRuler = () => {
        // flip the ruler by swapping the start and end points
        this.props.handleChange('flip', {});
    }

    isFlipRulerEnabled = () => {
        // disable if ruler is in absolute value mode
        return ! this.state.isAbs;
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc(str);
    };

    render = () => {
        let { Dyn } = this.props;
        return (
            <ContextMenuWrapper {...this.props} isColorPickerEnable={true}>
                <ContextMenuWrapper.Options>

                    <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between">
                        <label className="text-normal">
                            { this.getLoc("Ruler Color") }
                        </label>
                        <ColorPickerDot
                            color={this.props.colorHex}
                            colorsArray={this.props.colorsArray}
                            onChange={ (data) => { this.handleColorChange(data) }}
                            Dyn={Dyn} />
                    </div>

                    <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                        <label className="text-normal" htmlFor="tde-histogram-count-toggle">
                                <span className="flex-1">
                                    {this.getLoc("Absolute Value")}
                                    <ToolTip tip={
                                        this.getLoc( "Show the absolute value of the ruler" )}
                                        Dyn={Dyn}>
                                    <i className="tde-i tde-i-exclamation tde-ml-2" aria-label={
                                        this.getLoc( "Show the absolute value of the ruler, or the difference between the two ends of the ruler" )}>
                                    </i>
                                    </ToolTip>
                                </span>
                        </label>
                        <Toggle
                            aria-label={`${this.getLoc("Absolute Value")}, ${this.state.isAbs ? 'checked' : 'unchecked'}, checkbox`}
                            className="black-toggle"
                            checked={this.state.isAbs}
                            icons={false}
                            onChange={ (e) => { this.handleAbsToggle(e) }}
                        />
                    </div>

                    <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between">
                        <button title="Flip Ruler"
                                aria-label={this.getLoc('Flip Ruler')}
                                className={"tde-btn tde-font-weight-bold tde-px-4"}
                                style={{display: 'inline-block'}}
                                onClick={ this.handleFlipRuler }
                                disabled={!this.isFlipRulerEnabled()}>
                            {this.getLoc('Flip Ruler')}
                        </button>
                    </div>

                </ContextMenuWrapper.Options>
            </ContextMenuWrapper>
        );
    };
}

export default RulerContextMenu;
